import React, { useState } from "react";
import "./loginPage.scss";
import { RiHome2Fill } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import pgimage from "../../img/dates.jpg";

const Register = () => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [homeName, setHomeName] = useState("");
  const [landmark, setLandmark] = useState("");
  const [address, setAddress] = useState("");

  const navigate = useNavigate();

  const handleStRegister = async (e) => {
    e.preventDefault();

    if (!fullName || !password || !email) {
      setErrorMsg("Need to fill all fields");
      return;
    }

    setErrorMsg("");

    if (password !== rePassword) {
      setErrorMsg("Passwords do not match");
      return;
    }

    setLoading(true);
    const data = {
      fullName,
      email,
      password,
      phone,
      city,
      landmark,
      homeName,
      address
    };
    try {
      await axios.post("/buyer-register", data);
      navigate("/");
    } catch (error) {
      return;
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-right">
        <div></div>
        <form className="login-form" onSubmit={handleStRegister}>
          <div className="log_hed">
            <h2>
              Customer <em>Register</em>
            </h2>
            {/* <h5>Teacher Portal</h5> */}
          </div>

          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              va
              placeholder="Enter Full Name"
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="text"
              placeholder="Enter Email"
            />
          </div>
          <div className="form-group">
            <label>Phone</label>
            <input
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              type="text"
              placeholder="+971123456789"
            />
          </div>
          <div className="form-group">
            <label>City</label>
            <select
              name="city"
              id="city"
              value={city}
              required="required"
              onChange={(e) => setCity(e.target.value)}
            >
              <option>Select Your City </option>
              <option value="Abu Dhabi">Abu Dhabi</option>
              <option value="Dubai">Dubai</option>
              <option value="Sharjah">Sharjah</option>
              <option value="Ajman">Ajman</option>
              <option value="Umm Al-Quwain">Umm Al-Quwain</option>
              <option value="Fujairah">Fujairah</option>
              <option value="Ras Al Khaimah">Ras Al Khaimah</option>
              <option value="Al-Ain">Al-Ain</option>{" "}
            </select>
          </div>

          <div className="form-group">
            <label>Address</label>
            <input
              required
              type="text"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>House No. or Name</label>
            <input
              required
              type="text"
              value={homeName}
              onChange={(e) => setHomeName(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Landmark</label>
            <input
              required
              type="text"
              value={landmark}
              onChange={(e) => setLandmark(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter Password"
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={rePassword}
              onChange={(e) => setRePassword(e.target.value)}
              placeholder="Re-enter Password"
            />
          </div>
          {loading ? (
            <button className="login-btn">Please wait...</button>
          ) : (
            <button type="submit" className="login-btn">
              Register
            </button>
          )}

          {errorMsg && (
            <small
              style={{ fontSize: "10px", color: "red", marginTop: "10px" }}
            >
              {errorMsg}
            </small>
          )}
        </form>
        <div className="if_not">
          <small>
            Have an account?{" "}
            <Link to={'/login'}>
              <em>Login here</em>{" "}
            </Link>
          </small>
        </div>
        <div className="copy_right">
          <small>Copyright © Notions Group. All Rights Reserved.</small>
        </div>
      </div>
      <div
        className="login-left"
        style={{
          backgroundImage: `url(${pgimage})`,
          backgroundSize: "cover",
          backgroundPosition: "left",
          objectFit: "contain",
        }}
      >
        <div className="branding">
          {/* <h1>
            Welcome to <em> Mentora.lk</em>{" "}
          </h1>

          <h5>Learn Smarter. Grow Stronger</h5> */}
        </div>
      </div>
    </div>
  );
};

export default Register;
